import React from 'react';
import { AVAILABLE_MODULES } from '../../../hooks/admin/useSecurity';

const AdminUserModal = ({ security }) => {
  const {
    showAddAdminModal, editingAdmin, adminForm, setAdminForm,
    closeAdminModal, handleAdminFormSubmit,
  } = security;

  if (!showAddAdminModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-xl font-bold mb-4">{editingAdmin ? 'Edit Admin User' : 'Add Admin User'}</h3>
        <form onSubmit={handleAdminFormSubmit}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Username *</label>
              <input
                type="text"
                value={adminForm.username}
                onChange={(e) => setAdminForm({ ...adminForm, username: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
              <input
                type="text"
                value={adminForm.fullName}
                onChange={(e) => setAdminForm({ ...adminForm, fullName: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email *</label>
              <input
                type="email"
                value={adminForm.email}
                onChange={(e) => setAdminForm({ ...adminForm, email: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
              <input
                type="text"
                value={adminForm.phone}
                onChange={(e) => setAdminForm({ ...adminForm, phone: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
              />
            </div>
            {!editingAdmin && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
                <input
                  type="password"
                  value={adminForm.password}
                  onChange={(e) => setAdminForm({ ...adminForm, password: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
                  required
                />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
              <select
                value={adminForm.role}
                onChange={(e) => setAdminForm({ ...adminForm, role: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#d44100] focus:border-transparent"
              >
                <option value="ADMIN">Admin</option>
                <option value="SUPER_ADMIN">Super Admin</option>
                <option value="MANAGER">Manager</option>
                <option value="SUPPORT">Support</option>
              </select>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={adminForm.isActive}
                onChange={(e) => setAdminForm({ ...adminForm, isActive: e.target.checked })}
                className="h-4 w-4 text-[#d44100] focus:ring-[#d44100] border-gray-300 rounded mr-2"
              />
              <label className="text-sm text-gray-700">Active</label>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Module Permissions</label>
              <div className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto border border-gray-300 rounded-lg p-3">
                {AVAILABLE_MODULES.map((module) => (
                  <div key={module.id} className="flex items-center">
                    <input
                      type="checkbox"
                      checked={adminForm.permissions.includes(module.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setAdminForm({ ...adminForm, permissions: [...adminForm.permissions, module.id] });
                        } else {
                          setAdminForm({ ...adminForm, permissions: adminForm.permissions.filter((p) => p !== module.id) });
                        }
                      }}
                      className="mr-2"
                    />
                    <label className="text-sm text-gray-700">{module.name}</label>
                  </div>
                ))}
              </div>
              <p className="text-xs text-gray-500 mt-1">Select modules this admin can access</p>
            </div>
          </div>
          <div className="flex justify-end space-x-3 mt-6">
            <button type="button" onClick={closeAdminModal} className="px-4 py-2 border border-gray-300 rounded-lg">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-[#d44100] text-white rounded-lg hover:bg-[#b83700]">
              {editingAdmin ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminUserModal;
